import React ,{useState} from 'react';

import { styled } from '@mui/material/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';


const AntSwitch = styled(Switch)(({ theme }) => ({
	

  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : theme.palette.primary.main,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));
const RadioSwitch = ({ field, onChange, errors = {}, value, small = false }) => {
  let options = Object.values(field.options);
  let optionKeys = Object.keys(field.options);
  const [checked, setChecked] = useState(field.value===optionKeys[1]?true:false);
  return (
    <FormControl component="fieldset">
         <Stack direction="row" spacing={1}  alignItems="center">
        <Typography><strong>{options[0]}</strong></Typography>
        <AntSwitch defaultChecked={checked} value={field.value} color="primary" inputProps={{ 'aria-label': 'ant design' }}   onChange={(e) => onChange(field.value===optionKeys[1]?optionKeys[0]:optionKeys[1])} />
        <Typography><strong>{options[1]}</strong></Typography>
      </Stack>
    </FormControl>
  );
}

export default RadioSwitch;